import React, { Component } from 'react';
import propTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Button } from '@heroui/react';
import RightToolbarComponent from '../../UI/Toolbar/RightToolbar';
import RightToolbarItems from '../ToolbarItems';
import breakpointsMinWidth from '../../../../cra/src/styling/breakpointsMinWidth';
import ItemComponent from '../../UI/Toolbar/ToolbarItems';
import redirectAppURL from '../../../redirectApp';
import CommonToolbar from '../../../../cra/src/components/userDocuments/editDocument/editResume/Toolbar/DrawerToggle/DrawerToggle';
import { cleanPathname, featurePages } from '../../../constants/navbar';

const SignIn = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const SignUp = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-left: 16px;

  @media ${breakpointsMinWidth.tabletM} {
    margin-left: 20px;
  }
  button {
    ${({ isTop, isHomePage, isFeaturePage }) => {
      if (isFeaturePage) {
        return css`
          background-color: white !important;
          color: #2364eb !important;
        `;
      }
      if (!isHomePage) {
        return css`
          background-color: #2364eb !important;
          color: white !important;
        `;
      }
      if (isTop) {
        return css`
          background-color: white !important;
          color: #2364eb !important;
        `;
      }
      return css`
        background-color: #2364eb !important;
        color: white !important;
      `;
    }}
`;

const StyledButton = styled(Button)`
  ${({ isTop, isHomePage, isFeaturePage }) => {
    if (isFeaturePage) {
      return css`
        border-color: white !important;
        color: white !important;
      `;
    }
    if (!isHomePage) {
      return css`
        border-color: #122241 !important;
        color: #444746 !important;
      `;
    }
    if (isTop) {
      return css`
        border-color: white !important;
        color: white !important;
      `;
    }
    return css`
      border-color: #122241 !important;
      color: #444746 !important;
    `;
  }}
`;

class RightToolbar extends Component {
  renderDesktop = (
    rightList,
    pathname,
    user,
    isTop,
    inviteId,
    formatType,
    ProfileIcon,
    Notifications,
    appType,
    LinkComponent,
    ImageComponent,
  ) => {
    const isHomePage = pathname === '/';
    const isFeaturePage =
      featurePages.includes(cleanPathname(pathname)) && pathname !== '/';

    const getButtonStyles = () => {
      if (!isHomePage) {
        return 'text-[#444746] border-[#122241]';
      }
      if (isTop) {
        return 'text-white border-white';
      }
      return '!text-[#444746] !border-[#122241]';
    };
    return (
      <RightToolbarComponent
        pathname={pathname}
        user={user}
        formatType={formatType}
      >
        <RightToolbarItems
          list={rightList}
          trigger={this.handleItemClick}
          user={user}
          pathName={pathname}
          isTop={isTop}
          inviteId={inviteId}
          formatType={formatType}
          appType={appType}
          LinkComponent={LinkComponent}
          ImageComponent={ImageComponent}
        />
        {Notifications && <Notifications pathName={pathname} isTop={isTop} />}
        {ProfileIcon ? (
          <ProfileIcon appType={appType} pathName={pathname} isTop={isTop} />
        ) : (
          <ItemComponent className="signIn" pathname={pathname}>
            {/* here */}
            <SignIn
              href={redirectAppURL({
                appType,
                path: '/drive/myDrive',
              })}
              target="_blank"
            >
              <StyledButton
                variant="bordered"
                isHomePage={isHomePage}
                isFeaturePage={isFeaturePage}
                isTop={isTop}
                className={`${getButtonStyles()} rounded - [16px]`}
              >
                Login
              </StyledButton>
            </SignIn>
            <SignUp
              href={redirectAppURL({
                appType,
                path: '/drive/myDrive/?auth=Register',
              })}
              target="_blank"
              pathName={pathname}
              isTop={isTop}
              isHomePage={isHomePage}
              isFeaturePage={isFeaturePage}
            >
              <Button
                variant="solid"
                className="rounded-[16px] !bg-[white] !text-[#2364eb]"
              >
                Register
              </Button>
            </SignUp>
          </ItemComponent>
        )}
      </RightToolbarComponent>
    );
  };

  render() {
    const {
      rightList,
      pathname,
      user,
      userInfo,
      isTop,
      inviteId,
      formatType,
      setDrawerState,
      sideDrawerToggleHandler,
      appType,
      LinkComponent,
      ImageComponent,
      ProfileIcon,
      Notifications,
      MobileToolbar,
    } = this.props;

    return (
      <>
        {this.renderDesktop(
          rightList,
          pathname,
          user,
          isTop,
          inviteId,
          formatType,
          ProfileIcon,
          Notifications,
          appType,
          LinkComponent,
          ImageComponent,
        )}
        {appType === 'CRA' && !pathname.includes('/documents/') && (
          <MobileToolbar
            appType={appType}
            rightList={rightList}
            pathname={pathname}
            user={user}
            isTop={isTop}
            userInfo={userInfo}
            inviteId={inviteId}
            formatType={formatType}
            setDrawerState={setDrawerState}
            sideDrawerToggleHandler={sideDrawerToggleHandler}
            clicked={sideDrawerToggleHandler}
          />
        )}

        {appType === 'GATSBY' && !pathname.includes('/documents/') && (
          <CommonToolbar
            appType={appType}
            rightList={rightList}
            pathname={pathname}
            user={user}
            isTop={isTop}
            userInfo={userInfo}
            inviteId={inviteId}
            formatType={formatType}
            setDrawerState={setDrawerState}
            sideDrawerToggleHandler={sideDrawerToggleHandler}
            clicked={sideDrawerToggleHandler}
          />
        )}
      </>
    );
  }
}

RightToolbar.propTypes = {
  rightList: propTypes.objectOf(
    propTypes.oneOf([propTypes.string, propTypes.object]),
  ).isRequired,
  userInfo: propTypes.shape({ userInfo: propTypes.object }),
  user: propTypes.objectOf(propTypes.object),
  pathname: propTypes.string,
  isTop: propTypes.bool,
  webSocket: propTypes.shape({ user: propTypes.object }),
  inviteId: propTypes.string,
};

RightToolbar.defaultProps = {
  userInfo: undefined,
  user: {},
  pathname: '',
  isTop: false,
  inviteId: '',
  webSocket: {},
};

export default RightToolbar;
